import {Header as HeaderComponent, Content} from './Header'

export const Header = Object.assign(HeaderComponent, {Content})
